import { ApolloQueryResult, OperationVariables } from '@parkchirp/api-client';
import { FC } from 'react';

import { PaymentProvidersById, SetShowSnackbar } from '../../types';
import { GPICreditCardForm } from './gpi/gpiCreditCardForm';
import { SlidePayCreditCardForm } from './slidePay/slidePayCreditCardForm';

type FormProps = {
	paymentProviderId: number;
	subscriptionId: string;
	tenantSubscriptionId: string;
	cognitoSub: string;
	gpiFormConfig: Record<string, any>;
	setShowSnackbar: SetShowSnackbar;
	refetchPaymentMethods: (variables?: Partial<OperationVariables>) => Promise<ApolloQueryResult<any>>;
};

export const CreditCardForm: FC<FormProps> = ({
	paymentProviderId,
	subscriptionId,
	tenantSubscriptionId,
	cognitoSub,
	gpiFormConfig,
	setShowSnackbar,
	refetchPaymentMethods,
}) => {
	if (paymentProviderId === PaymentProvidersById.SlidePay) {
		return (
			<SlidePayCreditCardForm
				cognitoSub={cognitoSub}
				subscriptionId={subscriptionId}
				tenantSubscriptionId={tenantSubscriptionId}
				refetchPaymentMethods={refetchPaymentMethods}
				setShowSnackbar={setShowSnackbar}
			/>
		);
	}

	return (
		<GPICreditCardForm
			cognitoSub={cognitoSub}
			setShowSnackbar={setShowSnackbar}
			gpiFormConfig={gpiFormConfig}
			tenantSubscriptionId={tenantSubscriptionId}
			refetchPaymentMethods={refetchPaymentMethods}
		/>
	);
};
